import "./index.scss";

const LayoutContent = ({children}: any) => {
  return (
    <div className="layout-content-wrapper">
      {children}
    </div>
  );
}

export default LayoutContent;